import "../assets/scss/components/_category-header.scss";
import ReneHeader from "../assets/images/headers/rene-category.jpg";
import type { CategoryHeaderProps } from "../types/components/CategoryHeaderProps";
import { Image } from "./Image";

export const CategoryHeader = ({ specialName }: CategoryHeaderProps) => {
	switch (specialName) {
		case "rene":
			return (
				<div className="category-header rene-header">
					<Image src={ReneHeader} alt="Flowers By Rene Header" />
				</div>
			);
		default:
			return null;
	}
};

export default CategoryHeader;
